import TrialOrTestCaseTag from './TrialOrTestCaseTag'

export default TrialOrTestCaseTag
